import { render } from "./RefundListOfPayments.vue?vue&type=template&id=63f6eedc&ts=true"
import script from "./RefundListOfPayments.vue?vue&type=script&lang=ts"
export * from "./RefundListOfPayments.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__